import type { FeatureNavModule, FeatureRouteModule } from "../types";
import { FileText } from "lucide-react";
import { TraceabilityPage } from "@/pages/traceability";

export const traceabilityRoutes: FeatureRouteModule = {
  shellRoutes: [
    {
      path: "traceability",
      handle: { title: "Traceability Report" },
      element: <TraceabilityPage />,
    },
  ],
  shellRouteDefs: [
    {
      path: "/traceability",
      title: "Traceability Report",
      summary: "Link work items to test cases and show coverage, failures, and gaps.",
    },
  ],
};

export const traceabilityNav: FeatureNavModule = {
  navGroups: [
    {
      label: "Work",
      items: [
        {
          to: "/traceability",
          label: "Traceability Report",
          icon: FileText,
          end: false,
        },
      ],
    },
  ],
};
